
import React, { useEffect, useState } from 'react';
import { Link, useLocation } from 'react-router-dom';

function Footer() {

    const location = useLocation();


    const currentYear = new Date().getFullYear();


    return (
        <>
            <footer>
                <div className="container container-fixed-lg footer">
                    <div className="copyright sm-text-center">
                        <p className="small-text no-margin pull-left sm-pull-reset" style={{ paddingTopop: '5px' }}>©2026 All Rights Reserved. Psicopatici and/or its subsidiaries or affiliates are registered trademark of Psicopatici S.R.L.</p>
                        <div className="small no-margin pull-right sm-pull-reset">
                            <ul className="menu_footer">
                                <li><a href="https://store.psicopatici.com">Store</a></li>
                                <li><a href="https://partner.psicopatici.com">Partner</a></li>
                                <li><a href="https://legal.psicopatici.com/privacy-policy">Privacy Policy</a></li>
                                <li><a href="https://legal.psicopatici.com/terms-and-conditions">Termini & Condizioni</a></li>
                            </ul>
                        </div>
                        <div className="clearfix"></div>
                    </div>
                </div>
            </footer>

        </>
    );

}


export default Footer;